import Head from 'next/head';
import bytesToUuid from 'uuid/lib/bytesToUuid';
import base from 'base-x';
import user from '../src/services/api/user';
import countryApi from '../src/services/api/countries';
import priceApi from '../src/services/api/prices';
import quoteApi from '../src/services/api/quotes';
import Subscribe from '../src/components/Subscribe';

const BASE62 = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
const base62 = base(BASE62);

const HREF = '/souscrire';
const SUBSCRIBE_HREF = HREF;

const Index = ({ countries, prices, affiliateId, profile, quote }) => (
  <>
    <Head>
      <title key="title">YUPWEGO - Souscrire</title>
    </Head>
    <Subscribe
      countries={countries}
      prices={prices}
      apiKey={process.env.STRIPE_PUBLIC_KEY}
      affiliateId={affiliateId}
      profile={profile}
      quote={quote}
    />
  </>
);
Index.getInitialProps = async ({ req, res, query }) => {
  const affiliateId = query.affid
    ? bytesToUuid(base62.decode(query.affid))
    : null;
  const [countries, prices, profile, quote] = await Promise.all([
    countryApi.get(req),
    priceApi.get(req, res),
    user.profile(req, res),
    quoteApi.get(req, res)
  ]);
  return {
    countries,
    prices,
    affiliateId,
    profile,
    quote
  };
};

export default Index;
export { HREF, SUBSCRIBE_HREF };
